module.exports = __webpack_public_path__ + "static/img/share.a88b368.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/share.svg
// module id = 6Yu5
// module chunks = 0